import { useAppSelector } from '../../../hook/useAppSelector';
import { useFooterConfig } from '../../../hook/useFooterConfig';
import { useShowRowDensityMenu } from '../../../hook/useShowRowDensityMenu';
import { menus } from '../../../util/route/menus';

import ThumbnailView from '../Content/HealthMonitor/ThumbnailView';

import PageNavigator from './FooterOption/PageNavigator';
import RowDensityMenu from './FooterOption/RowDensityMenu';
import RowsPerPageMenu from './FooterOption/RowsPerPageMenu';

const Footer: React.FC = () => {
  const config = useFooterConfig(menus);

  const isThumbnailView = useAppSelector((state) => state.configSlice.isThumbnailView);
  const isMobile = useAppSelector((state) => state.configSlice.isMobile);

  const shouldShowRowDensity = useShowRowDensityMenu();

  return (
    <div className="row_footer">
      {!isMobile && (
        <>
          {!isThumbnailView && shouldShowRowDensity && <RowDensityMenu></RowDensityMenu>}
          {config.grid && <ThumbnailView></ThumbnailView>}
        </>
      )}
      {config.rowsPerPage && <RowsPerPageMenu></RowsPerPageMenu>}

      {config.pagging && <PageNavigator></PageNavigator>}
    </div>
  );
};

export default Footer;
